import React, {useContext} from "react";
import {create as createKite, deleteOne, filter, clone} from "../KiteDocuments/api";
import {KiteList} from "./KiteList";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {store} from "../store";
import {hasScope} from "../helpers/scopes";

export const KitesData = ({site, event, campaign, templates = false}) => {
  const queryClient = useQueryClient();
  const {state} = useContext(store);
  const canWrite = hasScope(state.user, 'kite-documents:write');

  const {isLoading = true, data: kites} = useQuery({
    queryKey: ['kitesData', site._id, event?._id, campaign?._id],
    queryFn: () => {
      const filterOptions = {siteId: site._id, eventId: event?._id, campaignId: campaign?._id };
      if (templates) {
        delete filterOptions.eventId;
        delete filterOptions.campaignId;
        filterOptions.type = "template";
      }
      return filter(filterOptions)
    },
    enabled: !!site?._id,
    refetchOnWindowFocus: false
  });

  const {isLoading: templatesLoading = true, data: kiteTemplates} = useQuery({
    queryKey: ['kiteTemplates', site._id],
    queryFn: () => filter({siteId: site._id, type: "template" }),
    enabled: !!site?._id,
    refetchOnWindowFocus: false
  });

  const triggerCreateKite = (state) => {
    const createOptions = {
      targetCustomer: state.targetCustomer,
      name: state.name,
      template: state.template,
      siteId: site ? site._id : null,
      ...(event && { eventName: event.groupName, eventId: event._id }),
      ...(campaign && { campaignId: campaign._id }),
    };
    if (templates) {
      createOptions.type = "template";
    }
    createKite(createOptions).then(() => {
      queryClient.invalidateQueries(['kitesData']);
    });
  }

  // function to clone a kite
  const cloneKite = (kite, options) => {
    clone({id: kite._id, ...options}).then(() => {
      queryClient.invalidateQueries(['kitesData']);
    });
  }

  const deleteKite = (kite) => {
    deleteOne(kite._id).then(() => queryClient.invalidateQueries(['kitesData']));
  }

  return (<KiteList
    kites={kites?.data}
    kiteTemplates={kiteTemplates?.data}
    siteNormalName={site?.normalName}
    deleteKite={canWrite ? deleteKite : undefined}
    cloneKite={canWrite ? cloneKite : undefined}
    editKite={canWrite}
    triggerCreateKite={canWrite ? triggerCreateKite : undefined}
    isLoading={isLoading || templatesLoading} />);
}
